import React, { useState } from "react";
import profileService from "../../services/profileService";

const DEFAULTS = {
  reminderEmail: true,
  reminderInApp: true,
  digestEmail: true,
  digestInApp: true,
  systemEmail: true,
  systemInApp: true,
};

function NotificationPreferences({ initial, onSaved }) {
  const [prefs, setPrefs] = useState({ ...DEFAULTS, ...(initial || {}) });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const toggle = (key) =>
    setPrefs((prev) => ({ ...prev, [key]: !prev[key] }));

  const save = async () => {
    setSaving(true);
    setError("");
    try {
      const res = await profileService.updateNotificationPrefs(prefs);
      if (res?.notificationPrefs) {
        setPrefs(res.notificationPrefs);
        onSaved?.(res.notificationPrefs);
      }
    } catch (e) {
      setError(e?.response?.data?.error || "Failed to save preferences");
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className="profile-section">
      <h3>Notification Preferences</h3>
      <p className="profile-section-desc">
        Choose how you want to be notified. These settings apply to reminder
        and digest emails going forward.
      </p>

      {error && (
        <div className="error-message">
          <i className="fas fa-exclamation-circle" /> {error}
        </div>
      )}

      <div className="profile-prefs">
        <div className="profile-prefs-row">
          <div className="profile-prefs-label">
            <strong>Reminder emails</strong>
            <small>Next Contact reminders by email</small>
          </div>
          <label className="switch">
            <input
              type="checkbox"
              checked={prefs.reminderEmail}
              onChange={() => toggle("reminderEmail")}
            />
            <span className="slider" />
          </label>
        </div>

        <div className="profile-prefs-row">
          <div className="profile-prefs-label">
            <strong>Reminder in-app</strong>
            <small>Next Contact reminders in the bell menu</small>
          </div>
          <label className="switch">
            <input
              type="checkbox"
              checked={prefs.reminderInApp}
              onChange={() => toggle("reminderInApp")}
            />
            <span className="slider" />
          </label>
        </div>

        <div className="profile-prefs-row">
          <div className="profile-prefs-label">
            <strong>Digest emails</strong>
            <small>Daily summary of overdue Next Contacts</small>
          </div>
          <label className="switch">
            <input
              type="checkbox"
              checked={prefs.digestEmail}
              onChange={() => toggle("digestEmail")}
            />
            <span className="slider" />
          </label>
        </div>

        <div className="profile-prefs-row">
          <div className="profile-prefs-label">
            <strong>System notifications</strong>
            <small>Account, sync and system messages</small>
          </div>
          <label className="switch">
            <input
              type="checkbox"
              checked={prefs.systemInApp}
              onChange={() => toggle("systemInApp")}
            />
            <span className="slider" />
          </label>
        </div>
      </div>

      <div className="form-actions">
        <button
          className="btn btn-primary"
          onClick={save}
          disabled={saving}
        >
          {saving ? (
            <>
              <i className="fas fa-spinner fa-spin" /> Saving...
            </>
          ) : (
            <>
              <i className="fas fa-save" /> Save Preferences
            </>
          )}
        </button>
      </div>
    </section>
  );
}

export default NotificationPreferences;